import { render, staticRenderFns } from "./CredenciamentoTimelineEventosPosPublicacao.vue?vue&type=template&id=24a54344"
import script from "./CredenciamentoTimelineEventosPosPublicacao.vue?vue&type=script&lang=js"
export * from "./CredenciamentoTimelineEventosPosPublicacao.vue?vue&type=script&lang=js"
import style0 from "./CredenciamentoTimelineEventosPosPublicacao.vue?vue&type=style&index=0&id=24a54344&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports